module.exports = __webpack_public_path__ + "static/media/promo-video.473a71ab.mp4";